import { render, staticRenderFns } from "./Notify.vue?vue&type=template&id=1cb9780f&scoped=true&"
import script from "./Notify.vue?vue&type=script&lang=ts&"
export * from "./Notify.vue?vue&type=script&lang=ts&"
import style0 from "./Notify.vue?vue&type=style&index=0&id=1cb9780f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../namtrung_logistics/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb9780f",
  null
  
)

export default component.exports